import { PaletteOptions } from '@material-ui/core/styles/createPalette'

export interface ColorsPalette extends PaletteOptions {
  colors?: {
    [key: string]: {
      50?: string
      100?: string
      200?: string
      300?: string
      400?: string
      500?: string
      600?: string
      700?: string
      800?: string
      900?: string
    }
  }
}

export const greenPalette = {
  500: '#5EA610',
}

export const purplePalette = {
  300: '#F7EDF7',
  400: '#9C5099',
  500: '#6A2375',
}

export const yellowPalette = {
  300: '#FFDD00',
  500: '#FFD000',
}

export const redPalette = {
  400: '#C95942',
  500: '#D53C1D',
}

export const tealPalette = {
  400: '#20CCD4',
  500: '#1CB2BA',
}

export const greyPalette = {
  200: '#F5F5F5',
  300: '#EBEBEB',
  400: '#959595',
  600: '#484848',
}

export const commonPalette = {
  white: '#fff',
  black: '#333',
}
